import { render, staticRenderFns } from "./SavedPostCard.vue?vue&type=template&id=54bae279&scoped=true"
import script from "./SavedPostCard.vue?vue&type=script&lang=js"
export * from "./SavedPostCard.vue?vue&type=script&lang=js"
import style0 from "./SavedPostCard.vue?vue&type=style&index=0&id=54bae279&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54bae279",
  null
  
)

export default component.exports